/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const labOrderTests = sqliteTable('lab_order_tests', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  lab_order_id: text('lab_order_id'),
  patient_id: text('patient_id'),
  service_id: text('service_id'),
  test_name: text('test_name'),
  test_code_snapshot: text('test_code_snapshot'),
  price_cents_snapshot: integer('price_cents_snapshot'),
  laboratory_department_id: text('laboratory_department_id'),
  laboratory_department_name_snapshot: text('laboratory_department_name_snapshot'),
  status: text('status'),
  sort_order: integer('sort_order'),
  collected_at: text('collected_at'),
  collected_by: text('collected_by'),
  started_at: text('started_at'),
  started_by: text('started_by'),
  result_ready_at: text('result_ready_at'),
  result_ready_by: text('result_ready_by'),
  published_at: text('published_at'),
  published_by: text('published_by'),
  cancelled_at: text('cancelled_at'),
  cancelled_by: text('cancelled_by'),
  cancel_reason: text('cancel_reason'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
